'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _mautic = require('../actions/mautic');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchSegments),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchSegmentsRequest);

function fetchSegments() {
    var response;
    return regeneratorRuntime.wrap(function fetchSegments$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/mautic/segments');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_mautic.actionCreators.fetchMauticSegmentsSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_mautic.actionCreators.fetchMauticSegmentsFailed(_context.t0));

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchSegmentsRequest() {
    return regeneratorRuntime.wrap(function fetchSegmentsRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_mautic.actionTypes.FETCH_MAUTIC_SEGMENTS_REQUEST, fetchSegments);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = [fetchSegmentsRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZWZmZWN0cy9tYXV0aWMuanMiXSwibmFtZXMiOlsiZmV0Y2hTZWdtZW50cyIsImZldGNoU2VnbWVudHNSZXF1ZXN0IiwicmVxdWVzdCIsInJlc3BvbnNlIiwiYWN0aW9uQ3JlYXRvcnMiLCJmZXRjaE1hdXRpY1NlZ21lbnRzU3VjY2VlZGVkIiwiZGF0YSIsImZldGNoTWF1dGljU2VnbWVudHNGYWlsZWQiLCJhY3Rpb25UeXBlcyIsIkZFVENIX01BVVRJQ19TRUdNRU5UU19SRVFVRVNUIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7bURBRVVBLGE7b0RBV0FDLG9COztBQVhWLFNBQVVELGFBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQUcrQixtQkFBS0UsWUFBTCxFQUFjLEtBQWQsRUFBcUIsa0JBQXJCLENBSC9COztBQUFBO0FBR2NDLDRCQUhkO0FBQUE7QUFBQSwyQkFLYyxrQkFBSUMsdUJBQWVDLDRCQUFmLENBQTRDRixTQUFTRyxJQUFyRCxDQUFKLENBTGQ7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBT2Msa0JBQUlGLHVCQUFlRyx5QkFBZixhQUFKLENBUGQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBV0EsU0FBVU4sb0JBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBQ1UseUJBQVdPLG9CQUFZQyw2QkFBdkIsRUFBc0RULGFBQXRELENBRFY7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O2tCQUllLENBQ1hDLG9CQURXLEMiLCJmaWxlIjoibWF1dGljLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjYWxsLCBwdXQsIHRha2VMYXRlc3QgfSBmcm9tICdyZWR1eC1zYWdhL2VmZmVjdHMnO1xuaW1wb3J0IHsgYWN0aW9uVHlwZXMsIGFjdGlvbkNyZWF0b3JzIH0gZnJvbSAnLi4vYWN0aW9ucy9tYXV0aWMnO1xuaW1wb3J0IHsgcmVxdWVzdCB9IGZyb20gJy4uL2FwaSc7XG5cbmZ1bmN0aW9uKiBmZXRjaFNlZ21lbnRzKCkge1xuXG4gICAgdHJ5IHtcbiAgICAgICAgY29uc3QgcmVzcG9uc2UgPSB5aWVsZCBjYWxsKHJlcXVlc3QsICdnZXQnLCAnL21hdXRpYy9zZWdtZW50cycpO1xuXG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25DcmVhdG9ycy5mZXRjaE1hdXRpY1NlZ21lbnRzU3VjY2VlZGVkKHJlc3BvbnNlLmRhdGEpKTtcbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICB5aWVsZCBwdXQoYWN0aW9uQ3JlYXRvcnMuZmV0Y2hNYXV0aWNTZWdtZW50c0ZhaWxlZChlcnJvcikpO1xuICAgIH1cbn1cblxuZnVuY3Rpb24qIGZldGNoU2VnbWVudHNSZXF1ZXN0KCkge1xuICAgIHlpZWxkIHRha2VMYXRlc3QoYWN0aW9uVHlwZXMuRkVUQ0hfTUFVVElDX1NFR01FTlRTX1JFUVVFU1QsIGZldGNoU2VnbWVudHMpO1xufVxuXG5leHBvcnQgZGVmYXVsdCBbXG4gICAgZmV0Y2hTZWdtZW50c1JlcXVlc3Rcbl07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/mautic.js
// module id = 2243
// module chunks = 0